var React = require('react');

function Cube (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")),React.createElement("path",{"className":"a","d":"M1.817,4.524l9.1-3.568a2.936,2.936,0,0,1,2.162,0l9.1,3.568A1.763,1.763,0,0,1,23.25,6.186V17.814a1.763,1.763,0,0,1-1.067,1.662l-9.1,3.569a2.956,2.956,0,0,1-2.162,0l-9.1-3.569A1.763,1.763,0,0,1,.75,17.814V6.186A1.763,1.763,0,0,1,1.817,4.524Z","key":1}),React.createElement("line",{"className":"a","x1":"12","y1":"9.353","x2":"1.104","y2":"5.081","key":2}),React.createElement("line",{"className":"a","x1":"12","y1":"9.353","x2":"22.896","y2":"5.081","key":3}),React.createElement("line",{"className":"a","x1":"12","y1":"23.25","x2":"12","y2":"9.353","key":4})]);
}

Cube.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Cube;

Cube.default = Cube;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs/cube.svg
// module id = 1066
// module chunks = 0